import { encodeProductNameForUri } from 'utils/encodeProductNameForUri';
import { encodeProductNameForUriOld } from 'utils/encodeProductNameForUriOld';

export const checkIfUriGenerationChanged = (
  name?: string | null
): { check: boolean; oldUri: string; newUri: string } => {
  if (!name) {
    return { check: false, oldUri: '', newUri: '' };
  }
  const oldUri = encodeProductNameForUriOld(name);
  const newUri = encodeProductNameForUri(name);

  return { check: oldUri !== newUri, oldUri, newUri };
};
